import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { SmsTemplateToken } from '@sleed/bizcommerce-api';
import { smsTemplatesApi } from '~/lib/api/client';
import { formToToken, type SmsTemplateFormValues } from '~/lib/schemas/sms-template';

export const smsTemplateKeys = { all: ['sms-templates'] as const, list: () => [...smsTemplateKeys.all, 'list'] as const };

export function useSmsTemplatesList() {
	return useQuery<SmsTemplateToken[]>({
		queryKey: smsTemplateKeys.list(),
		queryFn: async () => (await smsTemplatesApi.getAll()).data.items ?? []
	});
}

export function useSmsTemplateMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: smsTemplateKeys.list() });
	const create = useMutation({
		mutationFn: async (form: SmsTemplateFormValues) => (await smsTemplatesApi.insert(formToToken(form))).data,
		onSuccess: invalidate
	});
	const update = useMutation({
		mutationFn: async (form: SmsTemplateFormValues) => (await smsTemplatesApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({ mutationFn: async (id: number) => (await smsTemplatesApi.remove(id)).data, onSuccess: invalidate });
	return { create, update, remove };
}
